import React, { Component } from "react";
import { connect } from "react-redux";

import { switchCompany } from "actions/auth";
import { getCompanyInfo } from "actions/company";

class HomePortalMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "",
    };
  }

  getUserName() {
    const { auth_status } = this.props;
    const { user } = auth_status;
    let name = "User";

    if (user && user.firstname) {
      name = user.firstname;
    }

    return name;
  }

  render() {
    return (
      <div className="message-home-portal">
        <div className="home-welcome">WELCOME</div>
        <div className="home-name">{this.getUserName()}. </div>
        <div className="home-subtext">What would you like to do today?</div>
        <br />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
  };
}

export default connect(mapStateToProps, { switchCompany, getCompanyInfo })(
  HomePortalMessage
);
